import { Component } from '@angular/core';

@Component({
    selector: 'order',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class OrderComponent {}
